import React, { memo, useState, useEffect } from 'react';
// import { Panel } from 'appkit-react';
import { Card, Tooltip } from 'antd';
import { Animations } from 'appkit-react/lib/Animations';
// import SectionComment from '@components/CommentCenter/SectionComment';
import SectionComment from 'src/ddvComment/SectionComment';

// import '@style/components/card.scss';
import '../../../styles/components/card.scss';
import RichEditor from '@modules/questionnaires/complexity/richEditor';

const InsightCard = (props) => {
  // const [animActive, toggleAnimActive] = useState(true);
  // content is summary
  const {
    title,
    content,
    action = { title: '', clickHandler: () => {} },
    effect,
    afterAnimation = () => {},
    cate = null,
    withTooltip = true,
    sectionCommentProps = null,
    index,
    useRichText = true,
    variant,
    className: classNameProp,
  } = props;

  const isDrawerVariant = variant === 'drawer';
  const cardClassName = [
    'card-wrapper',
    isDrawerVariant ? 'gp-principle-card' : '',
    classNameProp,
  ]
    .filter(Boolean)
    .join(' ');

  const richEditorLinkProps = {
    placement: 'leftTop',
    getPopupContainer: () =>
      document.getElementsByClassName('project-detail')[0] || document.body,
  };

  const renderRichContent = () => {
    if (isDrawerVariant) {
      return (
        <div className="gp-principle-card__inner">
          <div className="gp-principle-card__title">
            <RichEditor
              onInitialContentChange={true}
              readOnly={true}
              linkPopoverProps={richEditorLinkProps}
              value={title || '-'}
              key={title}
            />
          </div>
          {cate}
          <div className="gp-principle-card__preview">
            <RichEditor
              onInitialContentChange={true}
              readOnly={true}
              linkPopoverProps={richEditorLinkProps}
              value={content || '-'}
              key={content}
            />
          </div>
        </div>
      );
    }

    return (
      <>
        <RichEditor
          onInitialContentChange={true}
          readOnly={true}
          linkPopoverProps={richEditorLinkProps}
          value={title || '-'}
        />
        {cate}
        <RichEditor
          onInitialContentChange={true}
          readOnly={true}
          linkPopoverProps={richEditorLinkProps}
          value={content || '-'}
        />
      </>
    );
  };

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [isCommentPopoverVisible, setIsCommentPopoverVisible] = useState(false);
  const actionNode = (
    <div className="action-title" onClick={action.clickHandler}>
      {action.title}
    </div>
  );
  const handleClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  const card = (
    <Card
      bordered={false}
      className={cardClassName}
      actions={[actionNode]}
      onClick={handleClick}
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
    >
      {sectionCommentProps ? (
        <SectionComment
          {...sectionCommentProps}
          getPopupContainer={() =>
            document.getElementsByClassName('insights-container')[0] ||
            document.getElementById('root')
          }
          onPopoverVisibleChange={setIsCommentPopoverVisible}
          placement={index > 2 ? 'topRight' : 'leftTop'}
        />
      ) : null}
      {useRichText ? (
        renderRichContent()
      ) : (
        <>
          <span className="card-title">{title || '-'}</span>
          {cate}
          <span className="card-content">{content || '-'}</span>
        </>
      )}
    </Card>
  );
  return (
    <Animations
      effect={effect || null}
      active={true}
      afterAnimation={afterAnimation}
    >
      {withTooltip ? (
        <Tooltip
          title={
            <div className="insight-title-tooltip">
              <div className="tooltip-subtitle">Insight</div>
              <div className="tooltip-content">{props.insight}</div>
            </div>
          }
          placement="right"
          overlayStyle={{ maxWidth: '34.375rem' }}
          visible={!isCommentPopoverVisible && tooltipVisible}
        >
          {card}
        </Tooltip>
      ) : (
        card
      )}
    </Animations>
  );
};

export default memo(InsightCard);
